import React, { Component } from 'react'
import {NavLink} from 'react-router-dom'
import {UserNav, Field, SelectDropdown, AlertCard, Load, Error} from './../../../components'
import Router from './../../../services/Router'
import {ButtonRouter, TheftsStyle} from './../../../styles'
import { withLoader } from '../../../hoc/withLoader'
import {fetchThefts} from './../../../services/ApiController'

class Thefts extends Component {
  state = {
    results: [],
    ref: '',
    models: '',
    lists: [],
    ready: true,
    error: '',
  }

  componentWillReceiveProps({data}){
    if (data !== this.props.data) {
      this.setState({
        lists: data.models,
      })
    }
  }

  updateModels = (data) => {
    this.setState({
      models: data
    })
  }

  addSerialNumber = (data) => {
    this.setState({ ref: data.value })
  }

  getResult = async (e) => {
    e.preventDefault()
    this.setState({
      ready: false,
    })
    if (this.state.ref !== '' && this.state.models !== '') {
      fetchThefts(this.state.models, this.state.ref).then((data) => {
        this.setState({
          results: data.results ? data.results : [],
          ready: true,
          error: !data.results || (data.results && data.results.length > 0) ? '' : 'No results'
        })
      }).catch(e => {
        console.log('Something wrong with thefts...')
      })
    } else {
      this.setState({
        error: 'Model and Serial Number are required !',
        ready: true,
      })
    }
    
  }

  render () {
    const {results, lists, ready, error} = this.state
    return (
      <div className={`thefts page-inner ${TheftsStyle}`}>
        <UserNav />
        <div className="thefts-nav">
          <ul className={`reset ${ButtonRouter} flex`}>
            <li>
              <NavLink to={Router.counterfeits.path} exact> <span>Counterfeits</span> </NavLink>
            </li>
            <li>
              <NavLink to={Router.thefts.path} exact> <span>Thefts</span> </NavLink>
            </li>
          </ul>
        </div>
        <div className="theft-container">
          <h2>Search a stolen watch</h2>
          <form className="flex">
            <div className="theft-select">
              <SelectDropdown label="Select a model" lists={lists} callback={this.updateModels} />
            </div>
            <div className="theft-ref">
              <Field onChange={this.addSerialNumber} type="text" id="serial-number" name="serial-number" value="" className=""> Serial Number (ex: 4492) </Field>
            </div>
            <div className="theft-submit">
              <button type="submit" className="btn-submit reset" onClick={this.getResult}> Search </button>
            </div>
          </form>
          {
            results.length === 0 && error && error !== '' && (<Error>{error}</Error>)
          }
          <div className="theft-result">
            {
              !ready && (
              <div className='theft-result__loader'>
                <Load width={24} height={24} />
              </div>
              )
            }
            {
              results &&
              results.length > 0 && results.map((result, index) => (
                <AlertCard  {...result} title={`${result.model}`} slug={`/thefts/${result.id}`} key={index} />
              ))
            }
          </div>
        </div>
      </div>
    )
  }
}

export default withLoader(Thefts, `/alerts/thefts`)


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Thefts.js